import { zodResolver as baseZodResolver } from "@hookform/resolvers/zod";
import type { ZodSchema } from "zod";

export function zodResolver<T extends Record<string, unknown>>(schema: ZodSchema<T>) {
  return baseZodResolver(schema);
}
